<template>
  <div>
    <el-select
      v-close-on-zoom
      :value="state.selectedCallId"
      placeholder="Select callee"
      :disabled="readonly"
      class="call-select"
      @input="(callId) => selectCall(callId)"
    >
      <el-option
        v-for="call in emitter.caseConf.dialogue.calls"
        :key="call.id"
        :label="call.callee.en"
        :value="call.id"
      />
    </el-select>
    <toggle-dialogue-effect
      effect-type="CALL"
      placeholder="Call item"
      :get-dialogue-items="getSelectedCallItems"
      :put-data="putDataWithCallId"
      v-bind="$props"
    />
  </div>
</template>

<script>
import get from 'lodash/get';

import ToggleDialogueEffect from './ToggleDialogueEffect.vue';

export default {
  name: 'call-action',
  components: {
    ToggleDialogueEffect,
  },
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control', 'type'],
  data() {
    return {
      state: {
        selectedCallId: null,
      },
    };
  },
  computed: {
    selectedCall() {
      const calls = get(this.emitter.caseConf, 'dialogue.calls', []);
      if (!calls) {
        return;
      }
      return calls.find((call) => call.id === this.state.selectedCallId);
    },
  },
  created() {
    const data = this.getData(this.ikey);
    this.state.selectedCallId = get(data, 'callId');
  },
  mounted() {
    this.emitter.trigger('process', this.control);
  },
  methods: {
    selectCall(callId) {
      this.state.selectedCallId = callId;
      // First time selecting a callee
      // We don't want to emit null id and
      // cause validation errors
      if (!this.getData(this.ikey)) {
        return;
      }
      this.putDataWithCallId(this.ikey, {
        type: 'CALL',
        id: null,
      });
    },
    putDataWithCallId(key, data) {
      this.putData(key, {
        ...data,
        callId: this.state.selectedCallId,
      });
      this.emitter.trigger('process', this.control);
    },
    getSelectedCallItems() {
      if (!this.selectedCall) {
        return [];
      }
      return this.selectedCall.items;
    },
  },
};
</script>

<style scoped>
</style>